<template>
  <BaseDialog
    v-model="showDialog"
    dialogIcon="mdi-briefcase-variant-outline"
    title="Firma"
    subtitle="Oppdater firma"
    btnActionName="Lagre"
    @action="save"
  >
    <template v-slot>
      <v-form v-if="contact" ref="form" v-model="valid">
        <v-text-field
          v-model="contact.mobile"
          class="mb-5"
          prepend-inner-icon="mdi-cellphone"
          color="primary"
          label="Mobil"
          filled
          hide-details="auto"
          autocomplete="organization"
          pattern="[0-9]*"
        ></v-text-field>
        <v-text-field
          v-model="contact.phone"
          class="mb-5"
          prepend-inner-icon="mdi-phone-in-talk-outline"
          color="primary"
          label="Telefon"
          filled
          hide-details="auto"
          autocomplete="organization"
          pattern="[0-9]*"
        ></v-text-field>
        <v-text-field
          v-model="contact.name"
          class="mb-5"
          prepend-inner-icon="mdi-briefcase-variant-outline"
          color="primary"
          label="Firmanavn"
          filled
          hide-details="auto"
          autocomplete="organization"
        ></v-text-field>
        <v-text-field
          v-model="contact.www"
          class="mb-5"
          prepend-inner-icon="mdi-web"
          color="primary"
          label="Web-adresse"
          filled
          hide-details="auto"
          autocomplete="off"
        ></v-text-field>
        <v-text-field
          v-model="contact.address"
          class="mb-5"
          prepend-inner-icon="mdi-map-marker-outline"
          color="primary"
          label="Adresse"
          filled
          hide-details="auto"
          autocomplete="off"
        ></v-text-field>
      </v-form>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import contactApi from "@/api/contactApi";
import { mapActions } from "vuex";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import notification from "@/helpers/notification";

export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    profile: {
      type: Object,
    },
  },
  data() {
    return {
      valid: false,
      contact: {} as any,
    };
  },
  methods: {
    ...mapActions({
      updateProfile: "shared/updateProfile",
    }),
    async save() {
      const isValid = (this as any).$refs?.form?.validate();

      if (isValid) {
        delete this.contact.contactPersons;
        await contactApi.update(this.contact).then((Response) => {
          this.updateProfile(Response);
          this.showDialog = false;
        });
      } else {
        notification.warn("Alle obligatoriske felter må fylles ut!");
      }
    },
    setData() {
      this.contact = { ...this.profile.contact };
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        if (this.value) {
          this.setData();
        }
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },

  components: {
    BaseDialog,
  },
});
</script>
